import { render } from "./person-detail.vue?vue&type=template&id=8590397c"
import script from "./person-detail.vue?vue&type=script&lang=js"
export * from "./person-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__